import templates from './templates.json';

export default templates;
